import { graphql } from '@teachino/shared-infrastructure';

export const createMaterialMutation = graphql(`
  mutation CreateMaterial(
    $topicId: String
    $name: String!
    $contentHtml: String
    $icon: String
    $initialIpiRequestId: String
    $newEditor: Boolean!
  ) {
    createMaterial(
      createMaterialInput: {
        topicId: $topicId
        position: -1
        name: $name
        icon: $icon
        initialIpiRequestId: $initialIpiRequestId
        contentHtml: { html: $contentHtml }
        newEditor: $newEditor
      }
    ) {
      __typename
      material {
        id
      }
    }
  }
`);
